
import 'reflect-metadata';
import { Component, Provide, Vue } from 'vue-property-decorator';
import { Navigator, Service } from '@/domain/providers';
import { container } from 'tsyringe';
import Services from '@/infrastructure/service';
import { Navigation } from 'zr-arch';
import Notify from '@/components/message/Notify.vue';
import Confirm from '@/components/confirm/Confirm.vue';

@Component({
    components: { Confirm, Notify },
})
export default class App extends Vue {
    @Provide(Service) service = container.resolve(Services);
    @Provide(Navigator) navigator = container.resolve(Navigation);
}
